export default {"src":"/_next/static/media/price.67560056.svg","height":57,"width":69};